import React from "react";
import { GridPanel, IGridPanelProps } from "../../../components/panels/GridPanel";

export type GetGridPanelProps = IGridPanelProps & { id: string }

export const getGridPanel = ({
  id,
  bgColour,
  title,
  gridColumns,
  headerAnchor,
  betterV2,
}: GetGridPanelProps) => (
  <GridPanel
    key={id}
    bgColour={bgColour}
    title={title}
    gridColumns={gridColumns}
    headerAnchor={headerAnchor}
    betterV2={betterV2}
  />
);
